import CIcon from "@coreui/icons-react";
import { CButton, CModalBody, CModalHeader } from "@coreui/react";
import React from "react";
import { DisplayRichText } from "src/components";
import StyledModal from "src/components/BasicModal/BasicModal.style";

const GuidanceModal = ({ show, closeModal, guidance }) => {
  return (
    <StyledModal show={show} onClose={closeModal} centered>
      <CModalHeader className="pb-0 pt-4 flex-column align-items-center text-center position-relative">
        <CButton
          style={{ position: "absolute", top: "1rem", right: "1rem" }}
          variant="ghost"
          type="button"
          color="primary"
          onClick={closeModal}
        >
          <CIcon name="cilX" />
        </CButton>
        <h3 style={{ fontWeight: 400 }} className="mb-3">
          Guidance
        </h3>
      </CModalHeader>
      <CModalBody className="p-4">
        <DisplayRichText style={{
          color:"white!important"
        }} value={guidance} />
      </CModalBody>
    </StyledModal>
  );
};

export default GuidanceModal;
